import { DesktopUtils } from './desktopsUtils'
import { DateUtils } from './dateUtils'

export class DeploymentsUtils {
  static parseDeployments (items) {
    return items.map((item) => {
      return DeploymentsUtils.parseDeploymentsItem(item)
    }) || []
  }

  static parseDeploymentsItem (deployment, { partial = false } = {}) {
    const {
      id,
      name,
      description,
      visible_desktops: visibleDesktops,
      started_desktops: startedDesktops,
      total_desktops: totalDesktops,
      tag_visible: visible,
      needs_booking: needsBooking,
      desktop_names: desktopNames,
      template_names: templateNames
    } = deployment
    const hasDesktopNames = desktopNames !== undefined
    const hasTemplateNames = templateNames !== undefined
    const isMultiDesktop = hasDesktopNames && Array.isArray(desktopNames) && desktopNames.length > 1 && hasTemplateNames && Array.isArray(templateNames) && templateNames.length > 1
    const out = {
      id,
      name,
      description,
      visibleDesktops,
      startedDesktops,
      totalDesktops,
      creatingDesktops: partial ? undefined : 0,
      visible,
      needsBooking,
      desktopName: hasDesktopNames ? (isMultiDesktop ? `${desktopNames.length} desktop types` : (hasDesktopNames && desktopNames[0]) || '') : undefined,
      template: hasTemplateNames ? (isMultiDesktop ? '' : (hasTemplateNames && templateNames[0]) || '') : undefined,
      isMultiDesktop: hasDesktopNames ? isMultiDesktop : undefined
    }
    if (!partial) return out
    return Object.fromEntries(Object.entries(out).filter(([, v]) => v !== undefined))
  }

  static parseDeployment (deployment, { partial = false } = {}) {
    // apiv4 uses tag_visible at the deployment root; old-frontend has always
    // read `visible`. Accept either so this parser works on the apiv4 wire
    // shape without a per-call adapter.
    const { id, name, desktop_name: desktopName, desktop_names: desktopNames, description, tag_visible: tagVisible, visible: legacyVisible, needs_booking: needsBooking, next_booking_start: nextBookingStart, next_booking_end: nextBookingEnd, booking_id: bookingId, total_desktops: totalDesktops, total_users: totalUsers, desktops_each_user: desktopsEachUser } = deployment
    const visible = tagVisible !== undefined ? tagVisible : legacyVisible
    const desktops = deployment.desktops
      ? deployment.desktops.map((desktop) => {
        return DeploymentsUtils.parseDeploymentDesktop(desktop)
      })
      : (partial ? undefined : [])
    const out = {
      id,
      name,
      desktops,
      description,
      desktopName,
      visible,
      needsBooking,
      bookingId,
      nextBookingStart: nextBookingStart === undefined ? undefined : (nextBookingStart ? DateUtils.utcToLocalTime(nextBookingStart) : ''),
      nextBookingEnd: nextBookingEnd === undefined ? undefined : (nextBookingEnd ? DateUtils.utcToLocalTime(nextBookingEnd) : ''),
      totalDesktops,
      totalUsers,
      desktopsEachUser,
      isMultiDesktop: Array.isArray(desktopNames) ? desktopNames.length > 1 : (partial ? undefined : false)
    }
    if (!partial) return out
    return Object.fromEntries(Object.entries(out).filter(([, v]) => v !== undefined))
  }

  static parseDeploymentDesktop (desktop, { partial = false } = {}) {
    const { id, ip, rdp, name, user, user_name: userName, user_photo: userPhoto, category_name: categoryName, group_name: groupName, state, viewer, viewers, image, accessed, needs_booking: needsBooking, next_booking_start: nextBookingStart, next_booking_end: nextBookingEnd, booking_id: bookingId, visible, tag } = desktop
    const out = {
      id,
      ip,
      rdp,
      name,
      user,
      userName,
      userPhoto,
      categoryName,
      groupName,
      image,
      state,
      viewer,
      viewers,
      buttonIconName: state === undefined ? undefined : (state ? DesktopUtils.buttonIconName(desktop) : ''),
      last: accessed,
      bookingId,
      needsBooking,
      nextBookingStart: nextBookingStart === undefined ? undefined : (nextBookingStart ? DateUtils.utcToLocalTime(nextBookingStart) : ''),
      nextBookingEnd: nextBookingEnd === undefined ? undefined : (nextBookingEnd ? DateUtils.utcToLocalTime(nextBookingEnd) : ''),
      visible,
      tag
    }
    if (!partial) return out
    return Object.fromEntries(Object.entries(out).filter(([, v]) => v !== undefined))
  }
}
